export function allLink() {
  $(function(){
    $('.js-allLink').css('cursor','pointer');
    $('.js-allLink').on('click',function () {
      window.location.href = $(this).find('a').attr('href');
    });
  })
}